import qs from 'qs'

import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'
import {get} from './fetch'
import services from '../config/services'

const {MYTIME_COMPANY_ID, MYTIME_PUBLIC_BOOKING_API} = services

const myTimeLocationsParams = qs.stringify(
  {
    include_business_hours: 'True',
    include_consumer_app_photos: 'True',
    include_location_groups: 'True',
  },
  {addQueryPrefix: true},
)

export const getShowroomLocations = () =>
  get(
    `${MYTIME_PUBLIC_BOOKING_API}/companies/${MYTIME_COMPANY_ID}/locations/${myTimeLocationsParams}`,
  ).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
